// src/api/endpoints/collateralReceived.js
// Alınan Teminatlar (Collateral Received) — bkz. docs/CollateralReceived-API.md
import { rootApi } from '../rootApi';

export const collateralReceivedApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getCollateralReceivedList: builder.query({
            query: (params) => ({
                url: 'v1/CollateralReceived/list',
                method: 'GET',
                params: {
                    sapDealerId: params?.sapDealerId || undefined,
                    numbers: params?.numbers || undefined,
                    type: params?.type ?? undefined,
                    currency: params?.currency || undefined,
                    validity: params?.validity || undefined,
                    bankName: params?.bankName || undefined,
                    startDate: params?.startDate || undefined,
                    endDate: params?.endDate || undefined,
                    pageNumber: params?.pageNumber ?? 1,
                    pageSize: params?.pageSize ?? 10,
                    languageId: params?.languageId ?? 2
                }
            }),
            transformResponse: (resp) => ({
                items: resp?.data?.items ?? [],
                totalCount: resp?.data?.totalCount ?? 0
            }),
            providesTags: (result) => (result?.items ? [...result.items.map(({ id }) => ({ type: 'CollateralReceived', id })), { type: 'CollateralReceived', id: 'LIST' }] : [{ type: 'CollateralReceived', id: 'LIST' }])
        }),

        getCollateralReceivedById: builder.query({
            query: ({ id, languageId }) => ({
                url: `v1/CollateralReceived/${id}`,
                method: 'GET',
                params: { languageId: languageId ?? 2 }
            }),
            transformResponse: (resp) => resp?.data ?? null,
            providesTags: (result, error, arg) => [{ type: 'CollateralReceived', id: arg?.id }]
        }),

        createCollateralReceived: builder.mutation({
            query: (body) => ({
                url: 'v1/CollateralReceived',
                method: 'POST',
                body
            }),
            invalidatesTags: [{ type: 'CollateralReceived', id: 'LIST' }]
        }),

        updateCollateralReceived: builder.mutation({
            query: (body) => ({
                url: 'v1/CollateralReceived',
                method: 'PUT',
                body
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CollateralReceived', id: 'LIST' },
                { type: 'CollateralReceived', id: arg?.id }
            ]
        }),

        deleteCollateralReceived: builder.mutation({
            query: (id) => ({
                url: `v1/CollateralReceived/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'CollateralReceived', id: 'LIST' },
                { type: 'CollateralReceived', id }
            ]
        }),
 
        exportCollateralReceivedToExcel: builder.query({
            query: (body) => ({
                url: 'v1/CollateralReceived/export-to-excel',
                method: 'POST',
                body
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount } = response.data;
                    return { fileBase64, fileName, contentType, recordCount };
                }
                throw new Error(response?.errorMessage || 'Export başarısız oldu');
            }
        })
    }),
    overrideExisting: false
});

export const {
    useGetCollateralReceivedListQuery,
    useLazyGetCollateralReceivedListQuery,
    useGetCollateralReceivedByIdQuery,
    useLazyGetCollateralReceivedByIdQuery,
    useCreateCollateralReceivedMutation,
    useUpdateCollateralReceivedMutation,
    useDeleteCollateralReceivedMutation,
    useLazyExportCollateralReceivedToExcelQuery
} = collateralReceivedApi;
